export default __webpack_public_path__ + "static/media/ideas_1.ae881a92.png";